import * as React from 'react';

import { IGdnGoogleAnalyticData } from './gdn-google-analytic.data';
import { IGdnGoogleAnalyticProps } from './gdn-google-analytic.props.autogenerated';
import { isAbsoluteUrl, isNonceEnabled, SDK_FRAGMENT_NAME } from '@msdyn365-commerce/core-internal';

const isRelativeUrl = (source: string): boolean => {
    return /^(?!www\.|(?:http|ftp)s?:\/\/|[A-Za-z]:\\|\/\/).*(\.js){1}$/.test(source);
};

export interface IGdnGoogleAnalyticViewProps extends IGdnGoogleAnalyticProps<IGdnGoogleAnalyticData> {}

/**
 *
 * GdnGoogleAnalytic component
 * @extends {React.PureComponent<IGdnGoogleAnalyticProps<IGdnGoogleAnalyticData>>}
 */
class GdnGoogleAnalytic extends React.PureComponent<IGdnGoogleAnalyticProps<IGdnGoogleAnalyticData>> {
    public render(): JSX.Element | null {
        const { config, context, telemetry, resources } = this.props;
        let source = config.inlineScript;

        if (!source || source === '' || isAbsoluteUrl(source) || isRelativeUrl(source)) {
            console.error(
                'Invalid inline script - Empty inline source defined or a url is being used as a source. Use default-external-script to load scripts from an external or relative url.',
                telemetry
            );
            return null;
        }

        if (source.includes('</script>')) {
            console.error('Invalid inline script - inline script should not contain html tags', telemetry);
            return null;
        }

        // If enabled, replace every {account} placeholder in the script.
        if (config.shouldPassAccountNum) {
            const user = context.request.user;
            const isAuthenticated = user?.isAuthenticated;
            const guestAccountNumText = resources.guestAccountNumText;

            // Use the authenticated user's customer account number when available.
            // Otherwise, fall back to the guest text.
            const accountNum = isAuthenticated ? user?.customerAccountNumber || guestAccountNumText : guestAccountNumText;

            // Replace all {account} tokens in the authored script.
            source = source.replace(/\{account\}/g, accountNum);
        }

        const nonceToken = context && isNonceEnabled(context.request);
        const scriptHtml = `<script ${nonceToken ? `nonce='${nonceToken}'` : ''}>${source}</script>`;
        return React.createElement(SDK_FRAGMENT_NAME, { key: this.props.id, dangerouslySetInnerHTML: { __html: scriptHtml } });
    }
}

export default GdnGoogleAnalytic;
